import { Dialog } from 'palette/Dialog';
import { ModalBoxBody, ModalBoxHeader } from 'palette/Modal';

interface SplashDialogProps {
    id: string;
    title: string;
    body: string;
    onClose: () => void;
}

function SplashDialog({
    id,
    title,
    body,
    onClose,
}: SplashDialogProps) {
    return (
        <Dialog
            id={id}
            size="small"
        >
            <ModalBoxHeader
                title={title}
                onClose={onClose}
            />
            <ModalBoxBody>
                {/* eslint-disable-next-line react/no-danger */}
                <p dangerouslySetInnerHTML={{ __html: body }} />
            </ModalBoxBody>
        </Dialog>
    );
}

export default SplashDialog;
